document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.template--gift-with-purchase .header');

  function updateHeaderBackground() {
    if (window.scrollY > 100) {
      header.classList.remove('transparent');
      header.classList.add('solid');
    } else {
      header.classList.remove('solid');
      header.classList.add('transparent');
    }
  }

  updateHeaderBackground(); // run on page load
  window.addEventListener('scroll', updateHeaderBackground);
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const shadowHost = document.querySelector(".template--gift-with-purchase2 .countdown__timer .countdown__timer-item .countdown__timer-flip.h1");

    if (shadowHost && shadowHost.shadowRoot) {
      const style = document.createElement("style");
      style.textContent = `
        countdown-timer-flip-digit:first-child{
          padding-right: 0!important;
        }
        countdown-timer-flip-digit:nth-child(2){
          padding-left: 0!important;
        }
      `;
      shadowHost.shadowRoot.appendChild(style);
    }
  }, 1000); // 1 second delay
});

document.addEventListener("DOMContentLoaded", function () {
    const shadowHosts = document.querySelectorAll(".template--gift-with-purchase .countdown__timer .countdown__timer-item .countdown__timer-flip.h1");

    shadowHosts.forEach(shadowHost => {
      if (shadowHost && shadowHost.shadowRoot) {
        const style = document.createElement("style");
        style.textContent = `
          countdown-timer-flip-digit:first-child {
            
            padding-right: 0 !important;
           
            
          }
          countdown-timer-flip-digit:nth-child(2) {
            padding-left: 0 !important;
           
          }
        `;
        shadowHost.shadowRoot.appendChild(style);
      }
    });
});